import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './CarouselButton.module.scss'

/** @type {import("./types").default} */
const CarouselButton = ({ isRight = false }) => (
  <div
    className={clsx('CarouselButton', classes.button, { [classes.right]: isRight })}
    data-testid={`carrousel-slide-${isRight ? 'right' : 'left'}`}
  >
    <Icon icon="caret-right" className={clsx(classes.icon)} />
  </div>
)

export default CarouselButton
